import type { TranslationKey } from "./en";

const hi: Partial<Record<TranslationKey, string>> = {
  "lang.label": "भाषा",
  "lang.select": "भाषा चुनें",
  "theme.toggle": "थीम बदलें",
  "theme.light": "लाइट मोड",
  "theme.dark": "डार्क मोड",
  "brand.name": "GuardAI by G-Data Labs",
  "brand.short": "GuardAI",
  "brand.subtitle": "सुरक्षा गश्त",
  "brand.guardSystem": "गार्ड सिस्टम",
  "console.director": "निदेशक कंसोल",
  "console.admin": "एडमिन कंसोल",
  "console.supervisor": "पर्यवेक्षक कंसोल",
  "role.administrator": "प्रशासक",
  "role.director": "निदेशक",
  "role.supervisor": "पर्यवेक्षक",
  "role.guard": "सुरक्षा गार्ड",
  "nav.dashboard": "डैशबोर्ड",
  "nav.liveActivity": "लाइव गतिविधि",
  "nav.devices": "डिवाइस",
  "nav.schedules": "शेड्यूल",
  "nav.calendar": "कैलेंडर",
  "nav.alerts": "अलर्ट",
  "nav.checkpoints": "चौकियाँ",
  "nav.reports": "रिपोर्ट",
  "nav.reportBuilder": "रिपोर्ट बिल्डर",
  "nav.askAi": "AI से पूछें",
  "nav.admin": "एडमिन",
  "nav.settings": "सेटिंग्स",
  "nav.deploy": "तैनाती",
  "nav.scanMap": "स्कैन मैप",
  "nav.users": "उपयोगकर्ता प्रबंधन",
  "common.save": "सहेजें",
  "common.cancel": "रद्द करें",
  "common.submit": "सबमिट करें",
  "common.delete": "हटाएं",
  "common.edit": "संपादित करें",
  "common.search": "खोजें",
  "common.filter": "फ़िल्टर",
  "common.export": "निर्यात",
  "common.clear": "साफ़ करें",
  "common.viewAll": "सभी देखें",
  "common.back": "वापस",
  "common.close": "बंद करें",
  "common.confirm": "पुष्टि करें",
  "common.add": "जोड़ें",
  "common.refresh": "रीफ़्रेश करें",
  "common.loading": "लोड हो रहा है…",
  "common.saving": "सहेजा जा रहा है…",
  "common.saved": "सहेजा गया",
  "common.error": "त्रुटि",
  "common.noData": "कोई डेटा नहीं",
  "common.required": "आवश्यक",
  "common.optional": "वैकल्पिक",
  "common.yes": "हां",
  "common.no": "नहीं",
  "common.all": "सभी",
  "common.none": "कोई नहीं",
  "common.name": "नाम",
  "common.status": "स्थिति",
  "common.location": "स्थान",
  "common.time": "समय",
  "common.date": "तारीख",
  "common.actions": "कार्रवाइयां",
  "common.today": "आज",
  "domain.scanEvent": "स्कैन इवेंट",
  "domain.scanEvents": "स्कैन इवेंट",
  "domain.checkpoint": "चेकपॉइंट",
  "domain.checkpoints": "चेकपॉइंट",
  "domain.hospital": "अस्पताल",
  "domain.hospitals": "अस्पताल",
  "domain.guard": "गार्ड",
  "domain.guards": "गार्ड",
  "domain.device": "डिवाइस",
  "domain.devices": "डिवाइस",
  "domain.patrol": "गश्त",
  "domain.security": "सुरक्षा",
  "domain.shift": "शिफ्ट",
  "domain.station": "स्टेशन",
  "search.placeholder": "गार्ड, स्थान या स्कैन खोजें…",
  "notif.title": "सूचनाएं",
  "notif.empty": "कोई नई सूचना नहीं",
  "notif.viewAll": "सभी सूचनाएं देखें",
  "notif.missedCheckpoint": "छूटे चेकपॉइंट का अलर्ट",
  "status.active": "सक्रिय",
  "status.inactive": "निष्क्रिय",
  "status.online": "ऑनलाइन",
  "status.offline": "ऑफ़लाइन",
  "status.pending": "लंबित",
  "status.approved": "स्वीकृत",
  "status.denied": "अस्वीकृत",
  "status.flagged": "फ़्लैग किया गया",
  "status.completed": "पूर्ण",
  "status.missed": "छूट गया",
  "status.onDuty": "ड्यूटी पर",
  "status.offDuty": "ड्यूटी से बाहर",
  "auth.signIn": "साइन इन करें",
  "auth.signingIn": "साइन इन हो रहा है…",
  "auth.signOut": "साइन आउट करें",
  "auth.username": "उपयोगकर्ता नाम",
  "auth.password": "पासवर्ड",
  "auth.loginFailed": "लॉगिन विफल",
  "auth.tagline": "सुरक्षा गार्ड किसी भी स्टेशन पर अपना बैज स्कैन करते हैं और पर्यवेक्षक एक सुरक्षित डैशबोर्ड पर तुरंत अपडेट देखते हैं।",
  "dashboard.title": "सुरक्षा गश्त हब",
  "dashboard.subtitle": "हर चेकपॉइंट पर रीयल-टाइम निगरानी",
  "dashboard.totalScans": "कुल स्कैन",
  "dashboard.activeGuards": "सक्रिय गार्ड",
  "dashboard.checkpoints": "चेकपॉइंट",
  "dashboard.openAlerts": "खुले अलर्ट",
  "dashboard.recentActivity": "हाल की गतिविधि",
  "dashboard.noActivity": "कोई हाल की गतिविधि नहीं",
  "live.title": "लाइव गश्त गतिविधि",
  "live.subtitle": "हर बैज स्कैन का रीयल-टाइम फ़ीड जैसे ही वह होता है",
  "live.empty": "अभी तक कोई गतिविधि नहीं",
  "live.waiting": "अगले स्कैन की प्रतीक्षा में…",
  "devices.title": "कनेक्टेड गश्त डिवाइस",
  "devices.subtitle": "क्षेत्र में हर स्कैनिंग डिवाइस की स्थिति",
  "devices.lastSeen": "अंतिम बार देखा गया",
  "devices.battery": "बैटरी",
  "devices.none": "कोई डिवाइस कनेक्ट नहीं",
  "schedules.title": "गश्त शेड्यूल",
  "schedules.subtitle": "गार्ड को शिफ्ट और चेकपॉइंट सौंपें",
  "schedules.addShift": "शिफ्ट जोड़ें",
  "schedules.none": "अभी तक कोई शेड्यूल नहीं",
  "alerts.title": "सुरक्षा अलर्ट",
  "alerts.subtitle": "छूटे चेकपॉइंट और फ़्लैग की गई घटनाएं जिन पर ध्यान देने की आवश्यकता है",
  "alerts.none": "कोई सक्रिय अलर्ट नहीं",
  "alerts.allClear": "सब ठीक है — किसी पर ध्यान देने की आवश्यकता नहीं।",
  "alerts.acknowledge": "स्वीकार करें",
  "alerts.resolve": "हल करें",
  "reports.title": "सुरक्षा रिपोर्ट",
  "reports.subtitle": "गश्त कवरेज, स्कैन मात्रा और अखंडता विश्लेषण",
  "reports.builderTitle": "रिपोर्ट बिल्डर",
  "reports.builderSubtitle": "पेशेवर रिपोर्ट डिज़ाइन करें — कोई कोडिंग आवश्यक नहीं।",
  "reports.generate": "रिपोर्ट जनरेट करें",
  "reports.noData": "इस रिपोर्ट के लिए कोई डेटा नहीं",
  "ask.title": "AI से पूछें",
  "ask.greeting": "आज मैं आपकी कैसे मदद कर सकता हूं?",
  "ask.placeholder": "अपनी गश्त, गार्ड या स्कैन के बारे में कुछ भी पूछें…",
  "ask.send": "भेजें",
  "ask.thinking": "सोच रहा है…",
  "admin.title": "सिस्टम प्रशासन",
  "admin.subtitle": "एक्सेस, अनुमोदन और सिस्टम स्वास्थ्य प्रबंधित करें",
  "admin.pendingApplications": "लंबित आवेदन",
  "admin.systemHealth": "सिस्टम स्वास्थ्य",
  "admin.uptime": "अपटाइम",
  "admin.storage": "स्टोरेज",
  "admin.users": "उपयोगकर्ता",
  "admin.latency": "लेटेंसी",
  "users.title": "उपयोगकर्ता प्रबंधन",
  "users.subtitle": "प्लेटफ़ॉर्म खाते जोड़ें, संपादित करें और निष्क्रिय करें",
  "users.addUser": "उपयोगकर्ता जोड़ें",
  "users.none": "कोई उपयोगकर्ता नहीं मिला",
  "settings.title": "सेटिंग्स",
  "settings.subtitle": "अपना खाता और प्राथमिकताएं प्रबंधित करें",
  "settings.account": "खाता",
  "settings.appearance": "रूप-रंग",
  "settings.notifications": "सूचनाएं",
  "settings.language": "भाषा",
  "deploy.title": "तैनाती योजनाकार",
  "deploy.subtitle": "चेकपॉइंट स्थान की योजना, कैप्चर और सत्यापन करें",
  "deploy.plan": "योजना",
  "deploy.capture": "कैप्चर",
  "deploy.verify": "सत्यापित करें",
  "map.title": "स्कैन मैप",
  "map.subtitle": "सुविधा भर में बैज स्कैन कहां हो रहे हैं",
  "map.noScans": "दिखाने के लिए कोई स्कैन नहीं",
  "profile.account": "खाता",
  "profile.settings": "सेटिंग्स",
  "profile.help": "सहायता और समर्थन",
  "profile.darkMode": "डार्क मोड",
  "profile.viewProfile": "प्रोफ़ाइल देखें",
  "footer.copyright": "© 2026 G-Data Labs. सर्वाधिकार सुरक्षित।",
  "footer.terms": "उपयोग की शर्तें",
  "footer.privacy": "गोपनीयता नीति",
  // ── Auto-added: full dashboard content translations ──
  "admin.addGuard": "गार्ड जोड़ें",
  "admin.addNewGuard": "नया गार्ड जोड़ें",
  "admin.addRoute": "मार्ग जोड़ें",
  "admin.alertEmail": "अलर्ट सूचना ईमेल",
  "admin.avgResponse": "औसत प्रतिक्रिया",
  "admin.checkpointTimeout": "चेकपॉइंट टाइमआउट (मिनट)",
  "admin.checkpointsCount": "चेकपॉइंट ({n})",
  "admin.colBadge": "बैज",
  "admin.colContact": "संपर्क",
  "admin.colGuard": "गार्ड",
  "admin.colLastActive": "अंतिम सक्रिय",
  "admin.colRole": "भूमिका",
  "admin.colRoutes": "मार्ग",
  "admin.deactivatedPreviewDesc": "व्यवस्थापकों को एक निष्क्रिय खाता इस तरह दिखाई देता है।",
  "admin.deactivatedPreviewTitle": "निष्क्रिय गार्ड का पूर्वावलोकन",
  "admin.difficultyEasy": "आसान",
  "admin.difficultyHard": "कठिन",
  "admin.difficultyMedium": "मध्यम",
  "admin.employeeId": "कर्मचारी आईडी:",
  "admin.errorAddGuard": "गार्ड जोड़ने में असमर्थ। कृपया पुनः प्रयास करें।",
  "admin.errorAllFields": "सभी फ़ील्ड आवश्यक हैं।",
  "admin.errorLoadDirectory": "अभी गार्ड निर्देशिका लोड नहीं की जा सकी।",
  "admin.fieldEmail": "ईमेल",
  "admin.fieldEmergencyContact": "आपातकालीन संपर्क",
  "admin.fieldEmployeeId": "Emory कर्मचारी आईडी",
  "admin.fieldFullName": "पूरा नाम",
  "admin.fieldPhone": "फ़ोन",
  "admin.fieldRole": "भूमिका",
  "admin.fieldTempPassword": "अस्थायी पासवर्ड",
  "admin.gpsThreshold": "GPS सटीकता सीमा (मीटर)",
  "admin.guardId": "गार्ड आईडी:",
  "admin.loadingDirectory": "गार्ड निर्देशिका लोड हो रही है…",
  "admin.moreCheckpoints": "+{n} और चेकपॉइंट",
  "admin.noGuards": "कोई गार्ड नहीं मिला। शुरू करने के लिए अपना पहला गार्ड जोड़ें।",
  "admin.noRoutesAssigned": "कोई मार्ग आवंटित नहीं",
  "admin.notGenerated": "उत्पन्न नहीं",
  "admin.passwordPolicy": "पासवर्ड नीति",
  "admin.passwordPolicyDesc": "मजबूत पासवर्ड लागू करें",
  "admin.patrolRoutes": "गश्ती मार्ग",
  "admin.placeholderTempPassword": "एक अस्थायी पासवर्ड सेट करें",
  "admin.resetSessions": "सभी सत्र रीसेट करें",
  "admin.roleAdmin": "व्यवस्थापक",
  "admin.roleDirector": "निदेशक",
  "admin.roleGuard": "गार्ड",
  "admin.roleSupervisor": "पर्यवेक्षक",
  "admin.saveConfiguration": "कॉन्फ़िगरेशन सहेजें",
  "admin.searchGuards": "गार्ड खोजें...",
  "admin.securitySettings": "सुरक्षा सेटिंग्स",
  "admin.sessionTimeout": "सत्र टाइमआउट",
  "admin.sessionTimeoutDesc": "निष्क्रियता के बाद स्वतः लॉगआउट",
  "admin.statusDeactivated": "निष्क्रिय",
  "admin.statusLabel": "स्थिति:",
  "admin.statusSuspended": "निलंबित",
  "admin.storageUsed": "उपयोग किया गया संग्रहण",
  "admin.systemConfiguration": "सिस्टम कॉन्फ़िगरेशन",
  "admin.systemStatus": "सिस्टम स्थिति",
  "admin.tabBadges": "बैज जनरेटर",
  "admin.tabGuards": "गार्ड प्रबंधन",
  "admin.tabRoutes": "मार्ग प्रबंधन",
  "admin.tabSettings": "सिस्टम सेटिंग्स",
  "admin.timeout1Hour": "1 घंटा",
  "admin.timeout2Hours": "2 घंटे",
  "admin.timeout30Min": "30 मिनट",
  "admin.timeout4Hours": "4 घंटे",
  "admin.totalScans": "कुल स्कैन",
  "admin.twoFactor": "द्वि-कारक प्रमाणीकरण",
  "admin.twoFactorDesc": "सभी पर्यवेक्षकों के लिए 2FA अनिवार्य करें",
  "admin.viewBadge": "बैज देखें",
  "alerts.acknowledged": "स्वीकृत",
  "alerts.activeAlerts": "सक्रिय अलर्ट",
  "alerts.allLocationsHealthy": "सभी स्थान ठीक हैं",
  "alerts.allPriorities": "सभी प्राथमिकताएं",
  "alerts.allStatus": "सभी स्थितियां",
  "alerts.allTypes": "सभी प्रकार",
  "alerts.apiError": "API त्रुटि",
  "alerts.assignedTo": "को सौंपा गया:",
  "alerts.critical": "गंभीर",
  "alerts.distanceAway": "{n} मी दूर",
  "alerts.exportTitle": "अलर्ट डेटा निर्यात करें",
  "alerts.filters": "फ़िल्टर",
  "alerts.guardLabel": "गार्ड {name}",
  "alerts.high": "उच्च",
  "alerts.invalidScan": "अमान्य स्कैन",
  "alerts.issuesDetected": "{n} समस्याएं पाई गईं",
  "alerts.loadFailed": "अलर्ट लोड करने में विफल",
  "alerts.loadFailedHint": "जांचें कि अलर्ट एंडपॉइंट तैनात है या नहीं।",
  "alerts.loadingAlerts": "अलर्ट लोड हो रहे हैं...",
  "alerts.low": "निम्न",
  "alerts.medium": "मध्यम",
  "alerts.noInvalidScans": "नवीनतम बैच में कोई अमान्य स्कैन नहीं है।",
  "alerts.noneMatchFilters": "आपके फ़िल्टर से मेल खाने वाला कोई अलर्ट नहीं मिला",
  "alerts.refreshTitle": "अलर्ट रीफ़्रेश करें",
  "alerts.resolved": "हल किया गया",
  "alerts.scanExceptions": "गश्त स्कैन अपवाद",
  "alerts.scanExceptionsSubtitle": "फ़ील्ड डिवाइस से आने वाले अमान्य स्कैन या API त्रुटियां",
  "alerts.tryAgain": "पुनः प्रयास करें",
  "alerts.typeEmergency": "आपातकाल",
  "alerts.typeMissedCheckpoint": "छूटा चेकपॉइंट",
  "alerts.typeSystem": "सिस्टम",
  "alerts.unknownGuard": "अज्ञात",
  "ask.accessDenied": "पहुँच अस्वीकृत",
  "ask.accessDeniedDesc": "AI से पूछें सुविधा केवल व्यवस्थापकों तक सीमित है।",
  "ask.askNow": "अभी पूछें",
  "ask.askedTimesOne": "{n} बार पूछा गया",
  "ask.askedTimesOther": "{n} बार पूछा गया",
  "ask.closeHistory": "इतिहास बंद करें",
  "ask.dateAtTime": "{date} को {time} बजे",
  "ask.encryptedPrivate": "एन्क्रिप्टेड और निजी विश्लेषण",
  "ask.errorMessage": "क्षमा करें, मैं उस प्रश्न को संसाधित नहीं कर सका। यह कनेक्शन समस्या या असमर्थित क्वेरी के कारण हो सकता है। कृपया अपना प्रश्न दोबारा लिखें या थोड़ी देर में फिर प्रयास करें।",
  "ask.exampleInvalidScans": "इस सप्ताह किन स्थानों पर सबसे अधिक अमान्य स्कैन दर्ज हुए?",
  "ask.exampleMissedScans": "पिछले 7 दिनों में 3 या अधिक स्कैन चूकने वाले गार्ड दिखाएँ।",
  "ask.exampleNoScansToday": "उन स्थानों की सूची बनाएँ जिन्हें आज कोई स्कैन नहीं मिला।",
  "ask.exampleOvernightScans": "रात में 22:00 से 06:00 के बीच कितने स्कैन दर्ज हुए?",
  "ask.frequentlyAsked": "अक्सर पूछे जाने वाले",
  "ask.hideSql": "SQL क्वेरी छिपाएँ",
  "ask.history": "इतिहास",
  "ask.inputPlaceholder": "कुछ ऐसा पूछें जैसे “कल किन स्थानों पर सबसे कम स्कैन हुए?”",
  "ask.noHistory": "अभी तक कोई इतिहास नहीं। शुरू करने के लिए एक प्रश्न पूछें।",
  "ask.noQueriesMatching": "\"{q}\" से मेल खाने वाली कोई क्वेरी नहीं",
  "ask.rowCountOne": "{n} पंक्ति",
  "ask.rowCountOther": "{n} पंक्तियाँ",
  "ask.searchPlaceholder": "पिछली क्वेरी खोजें...",
  "ask.showSql": "SQL क्वेरी दिखाएँ",
  "ask.subtitle": "गश्त अनुपालन, छूटे हुए चेकपॉइंट, गार्ड प्रदर्शन या स्थान रुझानों के बारे में पूछें।",
  "ask.tagline": "वास्तविक समय के गश्त डेटा पर आधारित",
  "ask.thisWeek": "इस सप्ताह",
  "ask.today": "आज",
  "ask.yesterday": "कल",
  "auth.applyToJoin": "हमारी टीम में शामिल होने के लिए आवेदन करें",
  "auth.email": "ईमेल",
  "auth.enterCredentials": "सिस्टम तक पहुंचने के लिए अपने क्रेडेंशियल दर्ज करें।",
  "auth.needAccess": "सुरक्षा प्रणाली तक पहुंच चाहिए?",
  "deploy.addFloor": "+ मंजिल",
  "deploy.addUnplannedCheckpoint": "अनियोजित चेकपॉइंट जोड़ें",
  "deploy.address": "पता",
  "deploy.allSaved": "सब सहेजा गया",
  "deploy.area": "क्षेत्र",
  "deploy.areaDescription": "क्षेत्र / विवरण",
  "deploy.areaLabel": "क्षेत्र:",
  "deploy.areaPlaceholder": "ER प्रवेश, एडमिन सुइट 200…",
  "deploy.areaSuite": "क्षेत्र / सुइट",
  "deploy.cameraError": "कैमरा त्रुटि:",
  "deploy.cancelScan": "स्कैन रद्द करें",
  "deploy.captureWalkthrough": "कैप्चर वॉकथ्रू",
  "deploy.capturedProgress": "{done} / {total} कैप्चर किए गए",
  "deploy.checkpointsCount": "चेकपॉइंट ({n})",
  "deploy.ckStatusCaptured": "कैप्चर किया गया",
  "deploy.ckStatusInstalled": "स्थापित",
  "deploy.ckStatusPlanned": "नियोजित",
  "deploy.ckStatusVerified": "सत्यापित",
  "deploy.clickAnywhereToPlace": "मार्कर रखने के लिए कहीं भी क्लिक करें",
  "deploy.clickFloorPlan": "फ़्लोर प्लान पर क्लिक करें…",
  "deploy.complete": "पूर्ण!",
  "deploy.completionReport": "समापन रिपोर्ट",
  "deploy.contactLabel": "संपर्क:",
  "deploy.contactPhone": "संपर्क फ़ोन",
  "deploy.createAndCapture": "बनाएं और कैप्चर करें",
  "deploy.createProject": "परियोजना बनाएं",
  "deploy.creating": "बना रहे हैं…",
  "deploy.dismiss": "खारिज करें",
  "deploy.editingCheckpoint": "चेकपॉइंट संपादित कर रहे हैं",
  "deploy.fileFormats": "PNG, JPG या PDF",
  "deploy.floor": "मंजिल",
  "deploy.floorColon": "मंजिल:",
  "deploy.floorLabel": "मंजिल:",
  "deploy.floorN": "मंजिल {n}",
  "deploy.floorPlanAlt": "मंजिल {n} का प्लान",
  "deploy.generated": "जनरेट किया गया:",
  "deploy.gettingGps": "GPS प्राप्त कर रहे हैं…",
  "deploy.gpsFailedRetry": "GPS विफल — पुनः प्रयास करें",
  "deploy.grabGps": "GPS लें",
  "deploy.hospitalNameRequired": "अस्पताल का नाम *",
  "deploy.initials": "आद्याक्षर: ______",
  "deploy.installVerify": "स्थापित करें और सत्यापित करें",
  "deploy.installedAlt": "स्थापित",
  "deploy.installedVerifiedProgress": "{done} / {total} स्थापित और सत्यापित",
  "deploy.locationDetail": "स्थान विवरण",
  "deploy.locationDetailPlaceholder": "मुख्य दरवाज़ों के बाईं ओर, हैंड सैनिटाइज़र के ऊपर…",
  "deploy.locationDetailShort": "मुख्य दरवाज़ों के बाईं ओर…",
  "deploy.locationLabel": "स्थान:",
  "deploy.markInstalledVerified": "स्थापित और सत्यापित के रूप में चिह्नित करें",
  "deploy.newCheckpoint": "नया चेकपॉइंट",
  "deploy.newDeploymentProject": "नई परिनियोजन परियोजना",
  "deploy.newProject": "नई परियोजना",
  "deploy.newUnplannedCheckpoint": "नया अनियोजित चेकपॉइंट",
  "deploy.noCameraFound": "कोई कैमरा नहीं मिला",
  "deploy.noCheckpointsHint": "\"मार्कर रखें\" पर क्लिक करें, फिर फ़्लोर प्लान पर क्लिक करें।",
  "deploy.noCheckpointsYet": "अभी तक कोई चेकपॉइंट नहीं।",
  "deploy.noProjectSelected": "कोई परियोजना चयनित नहीं",
  "deploy.noProjectSelectedHint": "ऊपर कोई मौजूदा परियोजना चुनें या नई बनाएं।",
  "deploy.noProjectsYet": "अभी तक कोई परियोजना नहीं।",
  "deploy.notYetVerified": "अभी तक सत्यापित नहीं",
  "deploy.notes": "नोट्स",
  "deploy.notesLabel": "नोट्स:",
  "deploy.notesPlaceholder": "लैंडमार्क नोट्स, माउंटिंग विवरण…",
  "deploy.placeCardHere": "कार्ड यहाँ रखें (कैप्चर से):",
  "deploy.placeMarker": "मार्कर रखें",
  "deploy.placementNotes": "स्थापन नोट्स",
  "deploy.placementNotesPlaceholder": "5 फ़ुट ऊँचाई, ईंट की दीवार, स्थायी चिपकने वाला…",
  "deploy.placementReferenceAlt": "स्थापन संदर्भ",
  "deploy.print": "प्रिंट करें",
  "deploy.printChecklist": "चेकलिस्ट प्रिंट करें",
  "deploy.qrPlaced": "QR रखा गया",
  "deploy.qrPrefix": "QR:",
  "deploy.recapture": "फिर से कैप्चर करें",
  "deploy.retakeInstalledPhoto": "स्थापित फ़ोटो फिर से लें",
  "deploy.retakePhoto": "फिर से फ़ोटो लें",
  "deploy.reverify": "फिर से सत्यापित करें",
  "deploy.saveCapture": "कैप्चर सहेजें",
  "deploy.scanAgain": "फिर से स्कैन करें",
  "deploy.scanQrCode": "QR कोड स्कैन करें",
  "deploy.scanToVerify": "सत्यापित करने के लिए स्कैन करें",
  "deploy.scanVerified": "स्कैन सत्यापित",
  "deploy.scannedPrefix": "स्कैन किया गया:",
  "deploy.selectProject": "एक परियोजना चुनें…",
  "deploy.selectProjectShort": "परियोजना चुनें…",
  "deploy.selectProjectToCapture": "कैप्चरिंग शुरू करने के लिए कोई परियोजना चुनें।",
  "deploy.selectProjectToVerify": "सत्यापन शुरू करने के लिए कोई परियोजना चुनें।",
  "deploy.simulation3d": "3D सिमुलेशन",
  "deploy.siteContactName": "साइट संपर्क का नाम",
  "deploy.speechNotSupported": "इस ब्राउज़र में वाक् पहचान समर्थित नहीं है।",
  "deploy.statusCapturing": "कैप्चरिंग",
  "deploy.statusComplete": "पूर्ण",
  "deploy.statusFabricating": "निर्माण",
  "deploy.statusInstalling": "स्थापना",
  "deploy.statusPlanning": "योजना",
  "deploy.stop": "स्टॉप",
  "deploy.stopNumber": "स्टॉप #{n}",
  "deploy.stopVoice": "रोकें",
  "deploy.takeInstalledPhoto": "स्थापित फ़ोटो लें",
  "deploy.takePhoto": "फ़ोटो लें",
  "deploy.total": "कुल",
  "deploy.unnamed": "अनाम",
  "deploy.unnamedLower": "अनाम",
  "deploy.unsavedChanges": "असहेजे गए परिवर्तन...",
  "deploy.uploadFloorPlan": "फ़्लोर प्लान अपलोड करें",
  "deploy.uploadFloorPlanFor": "मंजिल {n} के लिए फ़्लोर प्लान अपलोड करें",
  "deploy.uuidMatched": "UUID मेल खाया! QR सत्यापित।",
  "deploy.uuidMismatch": "UUID मेल नहीं खाता। गलत QR कार्ड।",
  "deploy.uuidPrefix": "UUID:",
  "deploy.verifiedCheckpoints": "सत्यापित चेकपॉइंट",
  "deploy.verifiedCount": "सत्यापित",
  "deploy.voice": "आवाज़",
  "deploy.walkthroughChecklistStops": "परिनियोजन वॉकथ्रू चेकलिस्ट — {n} स्टॉप",
  "devices.appVersion": "ऐप संस्करण",
  "devices.deviceManagement": "डिवाइस प्रबंधन",
  "devices.emptyHint": "जुड़े हुए डिवाइस टेलीमेट्री भेजते ही यहाँ दिखाई देंगे।",
  "devices.geofences": "जियोफेंस",
  "devices.hoursAgo": "{n} घंटे पहले",
  "devices.justNow": "अभी-अभी",
  "devices.lastLocation": "अंतिम स्थान",
  "devices.locateOnMap": "मानचित्र पर डिवाइस ढूँढें",
  "devices.minutesAgo": "{n} मिनट पहले",
  "devices.never": "कभी नहीं",
  "devices.noDevicesFound": "कोई डिवाइस नहीं मिला",
  "devices.noGpsData": "कोई GPS डेटा नहीं",
  "devices.refreshStatus": "स्थिति ताज़ा करें",
  "devices.violations": "उल्लंघन",
  "geofence.acknowledge": "स्वीकार करें",
  "geofence.acknowledged": "स्वीकृत",
  "geofence.acknowledging": "स्वीकार कर रहे हैं...",
  "geofence.actionHeader": "कार्रवाई",
  "geofence.allGeofences": "सभी जियोफ़ेंस",
  "geofence.create": "जियोफ़ेंस बनाएं",
  "geofence.createdBy": "द्वारा बनाया गया",
  "geofence.createdDate": "बनाने की तारीख",
  "geofence.deleteConfirmBody": "यह क्रिया पूर्ववत नहीं की जा सकती। जियोफ़ेंस स्थायी रूप से हटा दिया जाएगा।",
  "geofence.deleteConfirmTitle": "जियोफ़ेंस हटाएं?",
  "geofence.drawPolygon": "मानचित्र पर बहुभुज बनाएं",
  "geofence.drawPolygonHint": "बिंदु जोड़ने के लिए मानचित्र पर क्लिक करें। बहुभुज में कम से कम 3 बिंदु होने चाहिए। वर्तमान बिंदु: {n}",
  "geofence.edit": "जियोफ़ेंस संपादित करें",
  "geofence.enterName": "कृपया जियोफ़ेंस का नाम दर्ज करें",
  "geofence.failedCreate": "जियोफ़ेंस बनाने में विफल",
  "geofence.failedDelete": "जियोफ़ेंस हटाने में विफल",
  "geofence.failedLoad": "जियोफ़ेंस लोड करने में विफल",
  "geofence.failedSave": "जियोफ़ेंस सहेजने में विफल",
  "geofence.failedUpdate": "जियोफ़ेंस अपडेट करने में विफल",
  "geofence.filterByGeofence": "जियोफ़ेंस के अनुसार फ़िल्टर करें",
  "geofence.geofenceHeader": "जियोफ़ेंस",
  "geofence.gpsCoordinates": "GPS निर्देशांक",
  "geofence.hoursAgo": "{n} घंटे पहले",
  "geofence.justNow": "अभी",
  "geofence.management": "जियोफ़ेंस प्रबंधन",
  "geofence.managementSubtitle": "सुरक्षित क्षेत्र परिभाषित करें और सीमा उल्लंघनों की निगरानी करें",
  "geofence.minPoints": "बहुभुज में कम से कम 3 बिंदु होने चाहिए",
  "geofence.minutesAgo": "{n} मिनट पहले",
  "geofence.nameLabel": "जियोफ़ेंस का नाम",
  "geofence.namePlaceholder": "उदा., मुख्य प्रवेश, पार्किंग लॉट A",
  "geofence.noViolations": "कोई उल्लंघन नहीं मिला",
  "geofence.noViolationsHint": "सभी डिवाइस अपने निर्दिष्ट जियोफ़ेंस के भीतर हैं।",
  "geofence.noneConfigured": "आपके स्थान के लिए कोई जियोफ़ेंस कॉन्फ़िगर नहीं है।",
  "geofence.noneYet": "अभी तक कोई जियोफ़ेंस नहीं",
  "geofence.noneYetCanCreate": "सीमा निगरानी शुरू करने के लिए अपना पहला जियोफ़ेंस बनाएं।",
  "geofence.pointN": "बिंदु {n}:",
  "geofence.polygonPoints": "बहुभुज बिंदु ({n})",
  "geofence.preview": "पूर्वावलोकन",
  "geofence.save": "जियोफ़ेंस सहेजें",
  "geofence.selectHospitalAlert": "कृपया एक अस्पताल चुनें",
  "geofence.selectHospitalOption": "एक अस्पताल चुनें...",
  "geofence.unacknowledged": "अस्वीकृत",
  "geofence.unacknowledgedCount": "{n} अस्वीकृत",
  "geofence.violationsSubtitle": "सीमा उल्लंघनों की निगरानी करें और स्वीकार करें",
  "geofence.violationsTitle": "जियोफ़ेंस उल्लंघन",
  "help.callNow": "अभी कॉल करें",
  "help.comingSoon": "जल्द आ रहा है",
  "help.docsComingSoon": "दस्तावेज़ शीघ्र आ रहे हैं।",
  "help.emailSupport": "ईमेल समर्थन",
  "help.escalateIssue": "समस्या एस्केलेट करें",
  "help.guardHeadline": "गार्ड सहायता और समर्थन",
  "help.guidesFaq": "गाइड और अक्सर पूछे जाने वाले प्रश्न",
  "help.incidentEscalation": "घटना एस्केलेशन",
  "help.incidentEscalationDesc": "आउटेज, कियोस्क विफलताओं या तत्काल स्कैन समस्याओं की रिपोर्ट करें।",
  "help.intro": "Emory सुरक्षा गश्ती टीम से संपर्क करें या त्वरित समस्या-निवारण चरणों की समीक्षा करें।",
  "help.phoneHotline": "फ़ोन हॉटलाइन",
  "help.phoneHotlineValue": "(404) 555-0199 • 24/7",
  "help.quickTips": "त्वरित सुझाव",
  "help.sendEmail": "ईमेल भेजें",
  "help.supervisorHeadline": "पर्यवेक्षक सहायता और समर्थन",
  "help.support": "समर्थन",
  "help.tipAskAi": "समर्थन से संपर्क करने से पहले ऐतिहासिक डेटा प्राप्त करने के लिए Ask AI पेज का उपयोग करें।",
  "help.tipRefresh": "यदि स्कैन देरी से या पुराने दिखें तो पेज को रीफ़्रेश करें।",
  "help.tipReinstall": "जब आइकन गायब हो जाए तो गार्ड सेटिंग्स पेज से PWA को फिर से इंस्टॉल कर सकते हैं।",
  "home.activeCheckpoints": "सक्रिय चेकपॉइंट",
  "home.activeCheckpointsTooltip": "इस अस्पताल में वर्तमान में पंजीकृत भौतिक QR कोड स्थानों की कुल संख्या।",
  "home.addNewMarker": "नया मार्कर जोड़ें",
  "home.allHospitalsAggregated": "सभी अस्पताल (समेकित)",
  "hospitals.allAggregated": "सभी अस्पताल (समेकित)",
  "home.building": "भवन",
  "home.buildingFloor": "{building} - मंज़िल {floor}",
  "home.cancelPlacement": "स्थापन रद्द करें",
  "home.chartScans": "स्कैन:",
  "home.checkpointName": "चेकपॉइंट नाम",
  "home.checkpointNamePlaceholder": "उदा. वित्त (पश्चिम)",
  "home.checkpointsScanned": "स्कैन किए गए चेकपॉइंट",
  "home.chooseCheckpoint": "— एक चेकपॉइंट चुनें —",
  "home.cleared": "स्वीकृत",
  "home.clickToPlace": "नया मार्कर रखने के लिए मानचित्र पर कहीं भी क्लिक करें।",
  "home.comparingScanVolume": "सभी पंजीकृत साइटों पर सक्रिय स्कैन मात्रा की तुलना",
  "home.complianceRate": "अनुपालन दर",
  "home.complianceRateTooltip": "पंजीकृत चेकपॉइंट का प्रतिशत जिन्हें वर्तमान शिफ्ट के दौरान कम से कम एक बार स्कैन किया गया है।",
  "home.complianceRateValue": "अनुपालन दर: {n}%",
  "home.confirmDeleteCheckpoint": "क्या आप वाकई इस चेकपॉइंट को हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
  "home.createCustomCheckpoint": "+ कस्टम चेकपॉइंट बनाएं...",
  "home.deleteMarker": "मार्कर हटाएं",
  "home.dragToReposition": "स्थान बदलने के लिए मार्कर खींचें। परिवर्तन स्वचालित रूप से सहेजे जाते हैं।",
  "home.editModeOn": "संपादन मोड चालू",
  "home.editPositions": "स्थान संपादित करें",
  "home.failedDeleteLocation": "स्थान हटाने में विफल",
  "home.failedSaveLocation": "स्थान सहेजने में विफल",
  "home.floor": "मंज़िल",
  "home.floorAbbr": "मं. {n}",
  "home.floorN": "मंज़िल {n}",
  "home.headerSubtitle": "वास्तविक समय गश्त सत्यापन और हब अपलोड स्थिति",
  "home.hospitalPerformanceComparison": "अस्पताल प्रदर्शन तुलना",
  "home.hospitalSecurity": "अस्पताल सुरक्षा",
  "home.hub": "हब: {hub}",
  "home.internalServerError": "आंतरिक सर्वर त्रुटि",
  "home.lastHour": "पिछला घंटा",
  "home.lastScan": "अंतिम स्कैन",
  "home.lastUpdated": "अंतिम अद्यतन:",
  "home.legendError": "त्रुटि",
  "home.legendInvalid": "अमान्य",
  "home.legendOk": "ठीक",
  "home.liveSystem": "लाइव सिस्टम",
  "home.loadingCheckpoints": "चेकपॉइंट लोड हो रहे हैं...",
  "home.loadingComplianceData": "अनुपालन डेटा लोड हो रहा है...",
  "home.loadingUploads": "अपलोड लोड हो रहे हैं...",
  "home.mapLast30Days": "पिछले 30 दिन",
  "home.mapLast7Days": "पिछले 7 दिन",
  "home.mapLastQuarter": "पिछली तिमाही",
  "home.mapSubtitle": "वास्तविक समय गश्त ट्रैकिंग और चेकपॉइंट स्थिति",
  "home.mapTitle": "अस्पताल लाइव गतिविधि मानचित्र",
  "home.mapTodaysScans": "आज के स्कैन",
  "home.moreCheckpoints": "+ {n} और चेकपॉइंट",
  "home.noCheckpointsConfigured": "इस अस्पताल के लिए कोई चेकपॉइंट कॉन्फ़िगर नहीं किया गया है।",
  "home.noCheckpointsLoaded": "कोई चेकपॉइंट लोड नहीं हुआ। डेटाबेस कनेक्शन जांचें या नीचे मैन्युअल रूप से एक जोड़ें।",
  "home.noUploadsToday": "आज कोई अपलोड दर्ज नहीं किया गया।",
  "home.numberOfScans": "स्कैन की संख्या",
  "home.pendingClear": "स्वीकृति लंबित",
  "home.placeCheckpoint": "चेकपॉइंट रखें",
  "home.positionLabel": "स्थिति:",
  "home.qrPayload": "QR पेलोड",
  "home.qrPayloadPlaceholder": "उदा. FINANCE_WEST",
  "home.recentPatrolActivity7Days": "हाल की गश्त गतिविधि (7&nbsp;दिन)",
  "home.recentScans7Days": "हाल के स्कैन (7&nbsp;दिन)",
  "home.recentScansTooltip": "पिछले 7 दिनों में सफलतापूर्वक अपलोड और सत्यापित किए गए गश्त स्कैन की कुल संख्या।",
  "home.registeredCheckpoints": "पंजीकृत चेकपॉइंट",
  "home.roleDashboard": "{role} डैशबोर्ड:",
  "home.saveCheckpoint": "चेकपॉइंट सहेजें",
  "home.scanner": "स्कैनर: {serial}",
  "home.scansCount": "{n} स्कैन",
  "home.selectCheckpoint": "चेकपॉइंट चुनें",
  "home.tooltipPosition": "स्थिति",
  "home.unknownHospital": "अज्ञात अस्पताल",
  "home.uploadsByShift": "शिफ्ट के अनुसार अपलोड",
  "home.viewingHospital": "देखा जा रहा अस्पताल:",
  "landing.addressInfo": "पता जानकारी",
  "landing.agreeTerms": "मैं सेवा की शर्तों से सहमत हूं",
  "landing.agreeTermsDetail": "मैं समझता हूं कि सुरक्षा गश्त प्रणाली तक पहुंच पर्यवेक्षक की स्वीकृति पर निर्भर है और प्रदान की गई सभी जानकारी सटीक और पूर्ण है।",
  "landing.availableShifts": "उपलब्ध शिफ्ट (लागू सभी का चयन करें)",
  "landing.bulletIntegrity": "छूटे हुए स्कैन और फ्लैग किए गए इवेंट के लिए सत्यनिष्ठा विश्लेषण।",
  "landing.bulletMonitoring": "हर लॉबी, प्रवेश द्वार और गलियारे की रीयल-टाइम निगरानी।",
  "landing.bulletWorkspace": "त्वरित खोज और AI अंतर्दृष्टि के साथ एकीकृत पर्यवेक्षक कार्यक्षेत्र।",
  "landing.city": "शहर",
  "landing.completeAndAgree": "कृपया सभी आवश्यक फ़ील्ड पूरे करें और शर्तों से सहमत हों।",
  "landing.confirmPassword": "पासवर्ड की पुष्टि करें",
  "landing.confirmYourPassword": "अपने पासवर्ड की पुष्टि करें",
  "landing.createPassword": "एक सुरक्षित पासवर्ड बनाएं",
  "landing.dateOfBirth": "जन्म तिथि",
  "landing.emailAddress": "ईमेल पता",
  "landing.emailRegistered": "यह ईमेल पता पहले से पंजीकृत है।",
  "landing.emailRegisteredUseDifferent": "यह ईमेल पता पहले से पंजीकृत है। कृपया कोई दूसरा ईमेल पता उपयोग करें।",
  "landing.emergencyContact": "आपातकालीन संपर्क",
  "landing.emergencyContactName": "आपातकालीन संपर्क का नाम",
  "landing.emergencyContactPhone": "आपातकालीन संपर्क फ़ोन",
  "landing.fillRequiredContinue": "जारी रखने से पहले कृपया सभी आवश्यक फ़ील्ड भरें।",
  "landing.firstName": "पहला नाम",
  "landing.lastName": "उपनाम",
  "landing.next": "अगला",
  "landing.passwordsNoMatch": "पासवर्ड मेल नहीं खाते",
  "landing.percentComplete": "{p}% पूर्ण",
  "landing.personalInfo": "व्यक्तिगत जानकारी",
  "landing.phoneNumber": "फ़ोन नंबर",
  "landing.phoneRegistered": "यह फ़ोन नंबर पहले से पंजीकृत है।",
  "landing.phoneRegisteredUseDifferent": "यह फ़ोन नंबर पहले से पंजीकृत है। कृपया कोई दूसरा फ़ोन नंबर उपयोग करें।",
  "landing.relChild": "संतान",
  "landing.relFriend": "मित्र",
  "landing.relOther": "अन्य",
  "landing.relParent": "माता-पिता",
  "landing.relSibling": "भाई-बहन",
  "landing.relSpouse": "जीवनसाथी",
  "landing.relationship": "रिश्ता",
  "landing.requestAccessSubtitle": "सुरक्षा गश्त प्रणाली तक पहुंच का अनुरोध करने के लिए यह फ़ॉर्म भरें।",
  "landing.requestAccessTitle": "सिस्टम एक्सेस का अनुरोध करें",
  "landing.requestSubmitted": "खाता अनुरोध सबमिट किया गया",
  "landing.requestSubmittedApproval": "स्वीकृत होने के बाद आप अपने क्रेडेंशियल के साथ लॉग इन कर सकेंगे। इस प्रक्रिया में आमतौर पर 1-2 कार्यदिवस लगते हैं।",
  "landing.requestSubmittedThanks": "सुरक्षा गश्त प्रणाली तक पहुंच का अनुरोध करने के लिए धन्यवाद। आपका अनुरोध सबमिट कर दिया गया है और पर्यवेक्षकों की स्वीकृति के लिए लंबित है।",
  "landing.requestedRole": "अनुरोधित भूमिका",
  "landing.returnHome": "होम पर लौटें",
  "landing.returnToLogin": "लॉगिन पर लौटें",
  "landing.roleAvailability": "भूमिका और उपलब्धता",
  "landing.securityDirector": "सुरक्षा निदेशक",
  "landing.securitySupervisor": "सुरक्षा पर्यवेक्षक",
  "landing.selectEllipsis": "चुनें...",
  "landing.shiftDay": "दिन की शिफ्ट (सुबह 6 - दोपहर 2)",
  "landing.shiftEvening": "शाम की शिफ्ट (दोपहर 2 - रात 10)",
  "landing.shiftHolidays": "छुट्टियां",
  "landing.shiftNight": "रात की शिफ्ट (रात 10 - सुबह 6)",
  "landing.shiftOnCall": "ऑन-कॉल",
  "landing.shiftWeekends": "सप्ताहांत",
  "landing.signInSubheading": "जारी रखने के लिए अपने पर्यवेक्षक या गार्ड क्रेडेंशियल का उपयोग करें।",
  "landing.signInToGuard": "Guard में साइन इन करें",
  "landing.somethingWrong": "कुछ गलत हो गया।",
  "landing.state": "राज्य",
  "landing.stepOf": "चरण {n} / 4",
  "landing.streetAddress": "गली का पता",
  "landing.submitApplication": "आवेदन सबमिट करें",
  "landing.submitFailed": "आवेदन सबमिट करने में विफल। कृपया पुनः प्रयास करें।",
  "landing.submitting": "सबमिट किया जा रहा है...",
  "landing.termsOfService": "सेवा की शर्तें",
  "landing.zipCode": "ज़िप कोड",
  "live.action": "कार्रवाई",
  "live.activityFeed": "गतिविधि फ़ीड",
  "live.asOf": "{time} तक",
  "live.colCoordinate": "निर्देशांक",
  "live.colDateTime": "दिनांक और समय",
  "live.colDistance": "दूरी",
  "live.deviceLocation": "(डिवाइस स्थान)",
  "live.filterAll": "सभी गतिविधि",
  "live.filterInvalid": "अमान्य स्कैन",
  "live.filterValid": "वैध स्कैन",
  "live.floor": "मंज़िल {n}",
  "live.freshFix": "(ताज़ा फ़िक्स)",
  "live.loadingActivity": "गश्त गतिविधि लोड हो रही है…",
  "live.metersAway": "{n} मीटर दूर",
  "live.noGpsData": "कोई GPS डेटा नहीं",
  "live.noScansFilter": "इस फ़िल्टर से मेल खाने वाला कोई स्कैन नहीं।",
  "live.syncData": "डेटा सिंक करें",
  "live.timeframe": "समय-सीमा",
  "live.unknownHospital": "अज्ञात अस्पताल",
  "live.unknownLocation": "अज्ञात स्थान",
  "live.view3d": "3D दृश्य",
  "live.view3dWorld": "इस चेकपॉइंट की 3D दुनिया देखें",
  "map.allHospitals": "सभी अस्पताल",
  "map.autoRefresh": "स्वतः ताज़ा करें",
  "map.autoRefreshTitle": "हर 30 सेकंड में स्वतः ताज़ा करें",
  "map.dark": "गहरा",
  "map.expandLegend": "लीजेंड विस्तृत करें",
  "map.gpsDisclaimer": "स्कैन स्थितियाँ डिवाइस की GPS सटीकता दर्शाती हैं। इनडोर संकेत वास्तविक स्थान से 10–50 मीटर तक भिन्न हो सकते हैं।",
  "map.heatmap": "हीटमैप",
  "map.heatmapTitle": "घनत्व हीटमैप टॉगल करें",
  "map.legend": "लीजेंड",
  "map.light": "हल्का",
  "map.limitedWarning": "मानचित्र अधिकतम {max} स्कैन तक दिखाता है। विशिष्ट डेटा देखने के लिए कृपया अपना समय अंतराल या अस्पताल फ़िल्टर सीमित करें।",
  "map.loadFailed": "स्कैन लोड करने में विफल",
  "map.loadingScans": "स्कैन लोड हो रहे हैं…",
  "map.mapStyle": "मानचित्र शैली: {name}",
  "map.markers": "मार्कर",
  "map.minimizeLegend": "लीजेंड छोटा करें",
  "map.noGpsScans": "इस समय अंतराल के लिए कोई GPS-टैग किया गया स्कैन नहीं मिला।",
  "map.pageSubtitle": "स्कैन घटनाएँ कहाँ हुईं, इसका लाइव भौगोलिक दृश्य।",
  "map.pageTitle": "GuardAI स्कैन मानचित्र",
  "map.popupHospital": "अस्पताल:",
  "map.popupScanner": "स्कैनर:",
  "map.popupTime": "समय:",
  "map.rangeCustom": "कस्टम सीमा",
  "map.rangeLast24h": "पिछले 24 घंटे",
  "map.rangeLast30d": "पिछले 30 दिन",
  "map.rangeLast7d": "पिछले 7 दिन",
  "map.rangeLastHour": "पिछला घंटा",
  "map.showingMaxScans": "{total} स्कैन में से {shown} (अधिकतम) दिखाए जा रहे हैं",
  "map.snapToBuilding": "भवन से संरेखित करें",
  "map.snapToBuildingTitle": "इनडोर GPS विचलन की भरपाई के लिए GPS बिंदुओं को भवन केंद्रों की ओर संरेखित करें",
  "map.switchToDark": "गहरे मानचित्र पर स्विच करें",
  "map.switchToLight": "हल्के मानचित्र पर स्विच करें",
  "map.to": "से",
  "map.totalScans": "{total} स्कैन",
  "map.unknownHospital": "अज्ञात",
  "map.updatedAt": "अपडेट किया गया {time}",
  "reportBuilder.addWidget": "एक विजेट जोड़ें",
  "reportBuilder.aiAssistant": "AI रिपोर्ट सहायक",
  "reportBuilder.aiPlaceholder": "जिस रिपोर्ट की आप चाहते हैं उसका वर्णन करें — जैसे “पिछले महीने अस्पताल के अनुसार स्कैन गणना, बार चार्ट के साथ।” या कागज़ पर लेआउट बनाएं और फोटो अपलोड करें।",
  "reportBuilder.aiSummaryHint": "अपनी रिपोर्ट के डेटा से अवलोकन लिखने के लिए “जनरेट करें” पर क्लिक करें।",
  "reportBuilder.allHospitals": "सभी अस्पताल",
  "reportBuilder.allTime": "सभी समय",
  "reportBuilder.assistantUnavailable": "सहायक अभी उपलब्ध नहीं है।",
  "reportBuilder.author": "लेखक",
  "reportBuilder.beta": "बीटा",
  "reportBuilder.buildItForMe": "इसे मेरे लिए बनाएं",
  "reportBuilder.buildTogether": "चलिए इसे साथ मिलकर बनाते हैं",
  "reportBuilder.canvasEmpty": "आपका कैनवास खाली है",
  "reportBuilder.canvasEmptyHint": "ऊपर टूलबार से एक विजेट जोड़ें, बाईं ओर किसी डेटा फ़ील्ड पर क्लिक करें, या किसी टेम्पलेट से शुरू करें।",
  "reportBuilder.captionPlaceholder": "कैप्शन (वैकल्पिक)",
  "reportBuilder.color": "रंग",
  "reportBuilder.compareAgainst": "इससे तुलना करें",
  "reportBuilder.configure": "कॉन्फ़िगर करें",
  "reportBuilder.copySuffix": "(प्रति)",
  "reportBuilder.couldntSave": "सहेजा नहीं जा सका:",
  "reportBuilder.dataFields": "डेटा फ़ील्ड",
  "reportBuilder.dataFieldsHint": "अपनी रिपोर्ट में पहले से बना विजेट जोड़ने के लिए किसी भी फ़ील्ड पर क्लिक करें।",
  "reportBuilder.dataSource": "डेटा स्रोत",
  "reportBuilder.dateFrom": "{date} से",
  "reportBuilder.dateFromLabel": "दिनांक से",
  "reportBuilder.dateThrough": "{date} तक",
  "reportBuilder.dateToLabel": "दिनांक तक",
  "reportBuilder.dayOfWeekOpt": "सप्ताह का दिन",
  "reportBuilder.describeOrSketch": "जिस रिपोर्ट की आप चाहते हैं उसका वर्णन करें, या एक स्केच संलग्न करें।",
  "reportBuilder.dismiss": "खारिज करें",
  "reportBuilder.done": "पूर्ण",
  "reportBuilder.donutStyle": "डोनट शैली",
  "reportBuilder.draftedOffline": " · ऑफ़लाइन तैयार किया गया",
  "reportBuilder.duplicate": "डुप्लिकेट",
  "reportBuilder.example1": "पिछले महीने अस्पताल के अनुसार स्कैन गणना, बार चार्ट के साथ",
  "reportBuilder.example2": "पीक घंटों और सक्रिय उपकरणों के साथ दैनिक गश्त गतिविधि",
  "reportBuilder.example3": "चेकपॉइंट कवरेज: अस्पताल के अनुसार स्कैन किए गए बनाम बिना स्कैन किए",
  "reportBuilder.exportCsv": "CSV (डेटा)",
  "reportBuilder.exportFailed": "निर्यात विफल:",
  "reportBuilder.exportHtml": "HTML (साझा करने योग्य)",
  "reportBuilder.exportPdf": "PDF (प्रिंट के लिए तैयार)",
  "reportBuilder.exportPng": "PNG छवि",
  "reportBuilder.exportPrint": "प्रिंट करें",
  "reportBuilder.exportSlides": "स्लाइड के लिए तैयार (HTML)",
  "reportBuilder.exportTryPdf": "इसके बजाय PDF (प्रिंट) आज़माएं।",
  "reportBuilder.exportXls": "Excel (.xls)",
  "reportBuilder.fieldTitle": "शीर्षक",
  "reportBuilder.filterFloor": "फ़िल्टर: मंज़िल",
  "reportBuilder.filterHospital": "फ़िल्टर: अस्पताल",
  "reportBuilder.floorPlaceholder": "जैसे L1, 5, Plaza",
  "reportBuilder.generate": "जनरेट करें",
  "reportBuilder.generateBtn": "जनरेट करें",
  "reportBuilder.generatedBy": "GuardAI द्वारा जनरेट किया गया · © {year} G-Data Labs. सर्वाधिकार सुरक्षित।",
  "reportBuilder.generating": "जनरेट हो रहा है…",
  "reportBuilder.group": "समूह",
  "reportBuilder.groupBy": "इसके अनुसार समूहित करें",
  "reportBuilder.hideSettings": "सेटिंग्स छिपाएं",
  "reportBuilder.horizontal": "क्षैतिज",
  "reportBuilder.imageTooLarge": "वह छवि थोड़ी बड़ी है — कृपया 6 MB से छोटी छवि उपयोग करें।",
  "reportBuilder.imageUrlPlaceholder": "छवि URL (वैकल्पिक)",
  "reportBuilder.includeLogo": "GuardAI लोगो शामिल करें",
  "reportBuilder.loadFailed": "डेटा लोड नहीं हो सका।",
  "reportBuilder.lookAt": "{target} देखें",
  "reportBuilder.maxRows": "अधिकतम पंक्तियां",
  "reportBuilder.metric": "मेट्रिक",
  "reportBuilder.moreSettings": "अधिक सेटिंग्स",
  "reportBuilder.moveDown": "नीचे ले जाएं",
  "reportBuilder.moveUp": "ऊपर ले जाएं",
  "reportBuilder.next": "अगला",
  "reportBuilder.noDataSelection": "इस चयन के लिए कोई डेटा नहीं",
  "reportBuilder.noImageUploaded": "कोई छवि अपलोड नहीं की गई",
  "reportBuilder.noLayout": "मैं उसे लेआउट में नहीं बदल सका — मेट्रिक्स और उन्हें समूहित करने का तरीका बताने का प्रयास करें।",
  "reportBuilder.noSummary": "कोई सारांश जनरेट नहीं हुआ।",
  "reportBuilder.noWidgetsYet": "इस रिपोर्ट में अभी कोई विजेट नहीं है।",
  "reportBuilder.optionalSubtitle": "वैकल्पिक उपशीर्षक",
  "reportBuilder.orientation": "अभिविन्यास",
  "reportBuilder.period": "अवधि: {range}",
  "reportBuilder.preparedBy": "{name} द्वारा तैयार",
  "reportBuilder.preview": "पूर्वावलोकन",
  "reportBuilder.previewHint": "आपकी रिपोर्ट इसी तरह निर्यात और प्रिंट होगी। डाउनलोड करने के लिए ऊपर दिए गए निर्यात बटन का उपयोग करें।",
  "reportBuilder.regenerate": "फिर से जनरेट करें",
  "reportBuilder.remove": "हटाएं",
  "reportBuilder.removeImage": "छवि हटाएं",
  "reportBuilder.reportImage": "रिपोर्ट छवि",
  "reportBuilder.reportTitle": "रिपोर्ट शीर्षक",
  "reportBuilder.reportsAnalytics": "रिपोर्ट और विश्लेषण",
  "reportBuilder.saveAsTemplate": "वर्तमान रिपोर्ट को साझा टेम्पलेट के रूप में सहेजें",
  "reportBuilder.savedAt": "{time} पर सहेजा गया",
  "reportBuilder.savedReports": "सहेजी गई रिपोर्ट",
  "reportBuilder.secondSeriesLabel": "दूसरी श्रृंखला लेबल",
  "reportBuilder.secondSeriesMetric": "दूसरी श्रृंखला मेट्रिक",
  "reportBuilder.secondSeriesSource": "दूसरी श्रृंखला स्रोत",
  "reportBuilder.selectWidget": "इसे कॉन्फ़िगर करने के लिए एक विजेट चुनें।",
  "reportBuilder.seriesB": "श्रृंखला B",
  "reportBuilder.sketch": "स्केच",
  "reportBuilder.sketchAlt": "स्केच",
  "reportBuilder.sort": "क्रमबद्ध करें",
  "reportBuilder.sortLabelAsc": "नाम, A → Z",
  "reportBuilder.sortLabelDesc": "नाम, Z → A",
  "reportBuilder.sortValueAsc": "मान, कम → अधिक",
  "reportBuilder.sortValueDesc": "मान, अधिक → कम",
  "reportBuilder.startFromTemplate": "टेम्पलेट से शुरू करें",
  "reportBuilder.startNewReport": "नई रिपोर्ट शुरू करें",
  "reportBuilder.stepOf": "चरण {n} / {total}",
  "reportBuilder.subtitle": "उपशीर्षक",
  "reportBuilder.summaryFailed": "सारांश जनरेट करने में विफल।",
  "reportBuilder.targetAiBar": "AI सहायक बार",
  "reportBuilder.targetCanvas": "रिपोर्ट कैनवास",
  "reportBuilder.targetConfigPanel": "कॉन्फ़िगर पैनल",
  "reportBuilder.targetDataFields": "डेटा फ़ील्ड पैनल",
  "reportBuilder.targetExport": "निर्यात बटन",
  "reportBuilder.targetPreview": "पूर्वावलोकन टॉगल",
  "reportBuilder.targetSave": "सहेजें बटन",
  "reportBuilder.targetTemplates": "टेम्पलेट बटन",
  "reportBuilder.targetToolbar": "विजेट टूलबार",
  "reportBuilder.templates": "टेम्पलेट",
  "reportBuilder.textPlaceholder": "अपना टेक्स्ट लिखें। शीर्षक के लिए ## और ज़ोर देने के लिए **bold** का उपयोग करें।",
  "reportBuilder.thinking": "सोच रहा है…",
  "reportBuilder.title": "रिपोर्ट बिल्डर",
  "reportBuilder.total": "कुल",
  "reportBuilder.try": "आज़माएं:",
  "reportBuilder.untitledReport": "बिना शीर्षक रिपोर्ट",
  "reportBuilder.uploadSketchTitle": "हाथ से बनाए गए रिपोर्ट लेआउट की फोटो अपलोड करें",
  "reportBuilder.vertical": "ऊर्ध्वाधर",
  "reportBuilder.walkMeThrough": "मुझे चरण-दर-चरण समझाएं",
  "reportBuilder.widgetCountMany": "{n} विजेट",
  "reportBuilder.widgetCountOne": "{n} विजेट",
  "reportBuilder.width": "चौड़ाई",
  "reportBuilder.widthFull": "पूर्ण",
  "reportBuilder.working": "काम जारी है…",
  "reports.activeGuards": "सक्रिय गार्ड",
  "reports.asOfTime": "({time} तक)",
  "reports.averageCompliance": "औसत अनुपालन",
  "reports.averageResponseTime": "औसत प्रतिक्रिया समय",
  "reports.checkpointLocationAnalysis": "चेकपॉइंट स्थान विश्लेषण",
  "reports.checkpointsCompleted": "पूर्ण किए गए चेकपॉइंट",
  "reports.checkpointsLoggedGps": "(GPS डेटा से {n} चेकपॉइंट दर्ज किए गए)",
  "reports.colCompliance": "अनुपालन",
  "reports.colPerformance": "प्रदर्शन",
  "reports.compliance90to94": "90-94% अनुपालन",
  "reports.compliance95": "≥95% अनुपालन",
  "reports.complianceBelow90": "<90% अनुपालन",
  "reports.complianceLabel": "अनुपालन",
  "reports.complianceReport": "अनुपालन रिपोर्ट",
  "reports.coverageComplianceHelp": "इस समयावधि में कम से कम एक बार देखे गए चेकपॉइंट का %",
  "reports.coverageComplianceTrends": "कवरेज अनुपालन रुझान",
  "reports.criticalIssuesResolved": "हल किए गए महत्वपूर्ण मुद्दे",
  "reports.currentTime": "वर्तमान: {time}",
  "reports.dayFri": "शुक्र",
  "reports.dayFriday": "शुक्रवार",
  "reports.dayMon": "सोम",
  "reports.dayMonday": "सोमवार",
  "reports.daySat": "शनि",
  "reports.daySaturday": "शनिवार",
  "reports.daySun": "रवि",
  "reports.daySunday": "रविवार",
  "reports.dayThu": "गुरु",
  "reports.dayThursday": "गुरुवार",
  "reports.dayTue": "मंगल",
  "reports.dayTuesday": "मंगलवार",
  "reports.dayWed": "बुध",
  "reports.dayWednesday": "बुधवार",
  "reports.deltaLastMonth": "पिछले महीने से +1.8%",
  "reports.deltaLastQuarter": "पिछली तिमाही से +3.2%",
  "reports.deltaLastWeek": "पिछले सप्ताह से +2.1%",
  "reports.deltaYesterday": "कल से +1.5%",
  "reports.downloadReport": "रिपोर्ट डाउनलोड करें",
  "reports.exceptions": "अपवाद",
  "reports.exportFormat": "निर्यात प्रारूप",
  "reports.exportReport": "रिपोर्ट निर्यात करें",
  "reports.guardPerformanceAnalysis": "गार्ड प्रदर्शन विश्लेषण",
  "reports.heatmapCellTitle": "{location} - {label}: {pct}% गतिविधि",
  "reports.lessActivity": "कम गतिविधि",
  "reports.loadingPatrolActivity": "गश्त गतिविधि लोड हो रही है…",
  "reports.locationAbbreviations": "स्थान संक्षिप्ताक्षर:",
  "reports.locationActivityHeatmap": "स्थान गतिविधि हीटमैप",
  "reports.missedCheckpoints": "छूटे हुए चेकपॉइंट",
  "reports.missedCount": "{n} छूटे",
  "reports.monFeb": "फर",
  "reports.monJan": "जन",
  "reports.monMar": "मार्च",
  "reports.monthN": "महीना {n}",
  "reports.moreActivity": "अधिक गतिविधि",
  "reports.noChange": "कोई बदलाव नहीं",
  "reports.noCoverageData": "अभी तक कोई कवरेज डेटा नहीं",
  "reports.noDataForPeriod": "अवधि के लिए कोई डेटा नहीं",
  "reports.noScanLocations": "कोई QR कोड स्कैन स्थान उपलब्ध नहीं",
  "reports.notAvailable": "लागू नहीं",
  "reports.overallComplianceRate": "समग्र अनुपालन दर",
  "reports.patrolLocations": "गश्त स्थान",
  "reports.periodMonth": "इस महीने",
  "reports.periodQuarter": "इस तिमाही",
  "reports.periodToday": "आज",
  "reports.periodWeek": "इस सप्ताह",
  "reports.popupCompliance": "अनुपालन:",
  "reports.popupLast": "अंतिम:",
  "reports.popupScans": "स्कैन:",
  "reports.qrScanLocations": "QR कोड स्कैन स्थान",
  "reports.quickExportOptions": "त्वरित निर्यात विकल्प",
  "reports.realScanData": "वास्तविक स्कैन डेटा (पिछले 24 घंटे)",
  "reports.scanToSeeLocations": "मानचित्र पर स्थान देखने के लिए QR कोड स्कैन करें",
  "reports.scansCount": "{n} स्कैन",
  "reports.scansThisMonth": "इस महीने {n} स्कैन",
  "reports.scansThisQuarter": "इस तिमाही {n} स्कैन",
  "reports.scansThisWeek": "इस सप्ताह {n} स्कैन",
  "reports.scansToday": "आज {n} स्कैन",
  "reports.tabCompliance": "अनुपालन",
  "reports.tabGuardPerformance": "गार्ड प्रदर्शन",
  "reports.tabLocationAnalysis": "स्थान विश्लेषण",
  "reports.tabOverview": "अवलोकन",
  "reports.totalScans": "कुल स्कैन",
  "reports.trackingLocationsGuards": "{locations} स्थानों और {guards} गार्ड्स को ट्रैक किया जा रहा है।",
  "reports.trendDaily": "दैनिक प्रदर्शन रुझान",
  "reports.trendHourly": "प्रति घंटा प्रदर्शन रुझान",
  "reports.trendMonthly": "मासिक प्रदर्शन रुझान",
  "reports.trendTooltip": "{pct}% ({n} स्थान)",
  "reports.trendWeekly": "साप्ताहिक प्रदर्शन रुझान",
  "reports.validated": "सत्यापित",
  "reports.viewDetails": "विवरण देखें",
  "reports.weekN": "सप्ताह {n}",
  "reports.weeklySummary": "साप्ताहिक सारांश",
  "reports.wk1": "सप्ताह1",
  "reports.wk2": "सप्ताह2",
  "reports.wk3": "सप्ताह3",
  "reports.wk4": "सप्ताह4",
  "schedules.activeRoutes": "सक्रिय मार्ग",
  "schedules.activeSchedules": "सक्रिय शेड्यूल",
  "schedules.addNewSchedule": "नया शेड्यूल जोड़ें",
  "schedules.addSchedule": "शेड्यूल जोड़ें",
  "schedules.assignedGuard": "नियुक्त गार्ड",
  "schedules.assignedGuards": "नियुक्त गार्ड",
  "schedules.calendar": "कैलेंडर",
  "schedules.confirmDelete": "क्या आप वाकई इस शेड्यूल को हटाना चाहते हैं?",
  "schedules.coverageGaps": "कवरेज अंतराल",
  "schedules.createSchedule": "शेड्यूल बनाएं",
  "schedules.dayFri": "शुक्र",
  "schedules.dayMon": "सोम",
  "schedules.daySat": "शनि",
  "schedules.daySun": "रवि",
  "schedules.dayThu": "गुरु",
  "schedules.dayTue": "मंगल",
  "schedules.dayWed": "बुध",
  "schedules.daysOfWeek": "सप्ताह के दिन",
  "schedules.deleteSchedule": "शेड्यूल हटाएं",
  "schedules.editSchedule": "शेड्यूल संपादित करें",
  "schedules.endTime": "समाप्ति समय",
  "schedules.fillRequired": "कृपया सभी आवश्यक फ़ील्ड भरें",
  "schedules.frequency": "आवृत्ति",
  "schedules.frequencyCustom": "कस्टम",
  "schedules.frequencyDaily": "दैनिक",
  "schedules.frequencyWeekly": "साप्ताहिक",
  "schedules.listView": "सूची दृश्य",
  "schedules.morningPatrol": "सुबह की गश्त",
  "schedules.nightShift": "रात की पाली",
  "schedules.route": "मार्ग",
  "schedules.scheduleName": "शेड्यूल नाम",
  "schedules.scheduleNamePlaceholder": "उदा., सुबह की गश्त - भवन A",
  "schedules.selectGuard": "एक गार्ड चुनें",
  "schedules.selectRoute": "एक मार्ग चुनें",
  "schedules.selectedCount": "चयनित: {n} चेकपॉइंट",
  "schedules.startTime": "आरंभ समय",
  "schedules.updateSchedule": "शेड्यूल अपडेट करें",
  "settings.browserDesc": "डिवाइस की अखंडता की निगरानी के लिए UA रिकॉर्ड किया गया।",
  "settings.browserLabel": "ब्राउज़र",
  "settings.cameraDesc": "QR टैग स्कैन करने के लिए आवश्यक। अस्वीकृत होने पर सिस्टम सेटिंग्स में समायोजित करें।",
  "settings.cameraPermission": "कैमरा अनुमति",
  "settings.deviceIdDesc": "ऑडिट अनुपालन के लिए प्रत्येक स्कैन के साथ संग्रहीत फ़िंगरप्रिंट।",
  "settings.deviceIdLabel": "डिवाइस आईडी",
  "settings.email": "ईमेल",
  "settings.escalationAlerts": "एस्केलेशन अलर्ट",
  "settings.fullName": "पूरा नाम",
  "settings.installPwa": "PWA के रूप में इंस्टॉल करें",
  "settings.locationDesc": "प्रत्येक चेकपॉइंट पर GPS सत्यापन के लिए आवश्यक।",
  "settings.locationPermission": "स्थान अनुमति",
  "settings.mobilePhone": "मोबाइल फ़ोन",
  "settings.notRegistered": "अभी पंजीकृत नहीं",
  "settings.notificationDesc": "नियंत्रित करें कि पर्यवेक्षक टीम आपको कौन-सी अलर्ट भेज सकती है।",
  "settings.notificationPreferences": "सूचना प्राथमिकताएँ",
  "settings.permGranted": "प्रदान किया गया",
  "settings.permUnknown": "अज्ञात",
  "settings.profileDetails": "प्रोफ़ाइल विवरण",
  "settings.profileSavedMsg": "प्रोफ़ाइल प्राथमिकताएँ सहेजी गईं। परिवर्तन तुरंत प्रभावी होते हैं।",
  "settings.pwaAndroid": "Android (Chrome):",
  "settings.pwaAndroidSteps": "मेन्यू → ऐप इंस्टॉल करें।",
  "settings.pwaDesktop": "डेस्कटॉप:",
  "settings.pwaDesktopSteps": "एड्रेस बार में ब्राउज़र इंस्टॉल प्रॉम्प्ट का उपयोग करें।",
  "settings.pwaIos": "iOS (Safari):",
  "settings.pwaIosSteps": "शेयर पर टैप करें → होम स्क्रीन में जोड़ें।",
  "settings.saveProfile": "प्रोफ़ाइल सहेजें",
  "settings.storedLocally": "प्रोफ़ाइल सिंक उपलब्ध होने तक सेटिंग्स स्थानीय रूप से संग्रहीत रहती हैं।",
  "settings.weeklyEmailSummary": "साप्ताहिक ईमेल सारांश",
  "users.applicationDetails": "आवेदन विवरण",
  "users.applicationReview": "आवेदन समीक्षा:",
  "users.applicationStatus": "आवेदन स्थिति",
  "users.approve": "स्वीकृत करें",
  "users.approveApplication": "आवेदन स्वीकृत करें",
  "users.backToApplications": "आवेदनों पर वापस जाएं",
  "users.colApplicant": "आवेदक",
  "users.colRole": "भूमिका",
  "users.dateAdded": "जोड़ने की तारीख",
  "users.directoryFound": "employees_personal_info तालिका में पाया गया।",
  "users.directoryMatch": "निर्देशिका मिलान",
  "users.directoryName": "निर्देशिका नाम",
  "users.email": "ईमेल",
  "users.filterAll": "सभी आवेदन",
  "users.filterPending": "समीक्षा लंबित",
  "users.nextSteps": "अगले कदम",
  "users.noApplications": "कोई आवेदन नहीं मिला",
  "users.phone": "फ़ोन",
  "users.phoneNumber": "फ़ोन नंबर",
  "users.reject": "अस्वीकार करें",
  "users.rejectApplication": "आवेदन अस्वीकार करें",
  "users.requestedRole": "अनुरोधित भूमिका",
  "users.review": "समीक्षा",
  "users.statusRejected": "अस्वीकृत",
  "users.stepBackgroundCheck": "पृष्ठभूमि जांच शुरू करें",
  "users.stepCheckLicense": "लाइसेंस/प्रमाणन की वैधता जांचें",
  "users.stepScheduleInterview": "स्वीकृत होने पर साक्षात्कार निर्धारित करें",
  "users.stepVerifyReferences": "फ़ोन द्वारा संदर्भों की पुष्टि करें",
  "users.submitted": "प्रस्तुत:",
  "widget.aiSummary": "AI सारांश",
  "widget.barChart": "बार चार्ट",
  "widget.comparison": "तुलना",
  "widget.dataTable": "डेटा तालिका",
  "widget.dayOfWeek": "सप्ताह का दिन",
  "widget.image": "छवि",
  "widget.kpiRow": "KPI पंक्ति",
  "widget.lineChart": "लाइन चार्ट",
  "widget.metricCard": "मेट्रिक कार्ड",
  "widget.pieDonut": "पाई / डोनट",
  "widget.rankedTable": "रैंक की गई तालिका",
  "widget.textBlock": "टेक्स्ट ब्लॉक",

  // Activity calendar
  "calendar.title": "गश्त गतिविधि कैलेंडर",
  "calendar.subtitle": "हर चेकपॉइंट पर स्कैन गतिविधि, दिन-प्रतिदिन",
  "calendar.viewMonth": "माह",
  "calendar.viewWeek": "सप्ताह",
  "calendar.viewDay": "दिन",
  "calendar.viewList": "सूची",
  "calendar.today": "आज",
  "calendar.allHospitals": "सभी अस्पताल",
  "calendar.totalScans": "{n} स्कैन",
  "calendar.activeDays": "{n} सक्रिय दिन",
  "calendar.alertsCount": "{n} अलर्ट",
  "calendar.noActivityRange": "इस अवधि में कोई स्कैन गतिविधि नहीं।",
  "calendar.loading": "गतिविधि लोड हो रही है…",
  "calendar.loadFailed": "गतिविधि लोड करने में विफल",
  "calendar.refresh": "रिफ्रेश करें",
  "calendar.colTime": "समय",
  "calendar.colHospital": "अस्पताल",
  "calendar.colCheckpoint": "चेकपॉइंट",
  "calendar.colDevice": "डिवाइस",
  "calendar.colGuard": "गार्ड",
  "calendar.violation": "उल्लंघन",
  "calendar.violationsCount": "{n} उल्लंघन",
  "calendar.scansShort": "{n} स्कैन",
  "calendar.hospitalsActive": "{n} अस्पताल सक्रिय",
  "calendar.moreEvents": "+{n} और",
  "calendar.weekOf": "{date} का सप्ताह",
  "calendar.dayEvents": "स्कैन इवेंट",
  "calendar.hourlyDistribution": "घंटेवार वितरण",
  "calendar.legendLess": "कम",
  "calendar.legendMore": "अधिक",
  "calendar.unknownHospital": "अज्ञात अस्पताल",
  "calendar.unknownGuard": "अज्ञात गार्ड",
  "calendar.unknownCheckpoint": "अज्ञात चेकपॉइंट",

  // --- Synced from en.ts: newer pages (officers, compliance, checkpoints, patrol reports) ---
  "nav.compliance": "अनुपालन",
  "nav.officers": "अधिकारी",
  "nav.patrolReports": "गश्त रिपोर्ट",
  "common.retry": "पुनः प्रयास करें",
  "common.collapse": "संक्षिप्त करें",
  "common.expand": "विस्तृत करें",
  "home.comparisonVsMapNote": "गणना में हर दर्ज किया गया स्कैन शामिल है। स्कैन मैप केवल GPS निर्देशांक वाले स्कैन दर्शाता है, इसलिए इसका कुल कम हो सकता है।",
  "live.colOfficer": "अधिकारी",
  "live.unattributed": "अनारोपित",
  "map.trailNote": "बिंदुओं का रंग स्कैन समय के अनुसार है। स्कैन के बीच कोई पथ नहीं खींचा जाता — केवल दर्ज किए गए स्कैन स्थान दिखाए जाते हैं।",
  "checkpoints.directoryTitle": "चेकपॉइंट निर्देशिका",
  "checkpoints.directorySubtitle": "हर पंजीकृत QR चेकपॉइंट, मंज़िल के अनुसार व्यवस्थित",
  "checkpoints.searchPlaceholder": "नाम, कोड या भवन से खोजें…",
  "checkpoints.countShown": "{n} चेकपॉइंट",
  "checkpoints.exportCsv": "CSV निर्यात करें",
  "checkpoints.loadingDirectory": "चेकपॉइंट लोड हो रहे हैं…",
  "checkpoints.empty": "इस अस्पताल के लिए कोई चेकपॉइंट नहीं मिला।",
  "checkpoints.noFloor": "अनिर्दिष्ट",
  "checkpoints.floorLabel": "मंज़िल {n}",
  "checkpoints.colCode": "कोड",
  "checkpoints.colName": "नाम",
  "checkpoints.colBuilding": "भवन",
  "checkpoints.colFloor": "मंज़िल",
  "checkpoints.colLastScanned": "अंतिम स्कैन",
  "checkpoints.colTotalScans": "कुल स्कैन",
  "checkpoints.colStatus": "स्थिति",
  "checkpoints.active": "सक्रिय",
  "checkpoints.inactive": "निष्क्रिय",
  "checkpoints.never": "कभी नहीं",
  "checkpoints.untitled": "बिना शीर्षक चेकपॉइंट",
  "checkpoints.totalScans": "कुल स्कैन",
  "checkpoints.compliance": "अनुपालन",
  "checkpoints.late": "विलंबित",
  "checkpoints.missed": "छूटा",
  "checkpoints.fromDate": "से",
  "checkpoints.toDate": "तक",
  "checkpoints.clearDates": "साफ़ करें",
  "checkpoints.loadingHistory": "स्कैन इतिहास लोड हो रहा है…",
  "checkpoints.noScans": "चयनित सीमा में इस चेकपॉइंट के लिए कोई स्कैन दर्ज नहीं हुआ।",
  "checkpoints.unknownDevice": "अज्ञात डिवाइस",
  "checkpoints.noGps": "कोई GPS नहीं",
  "checkpoints.statusOnTime": "समय पर",
  "checkpoints.statusLate": "विलंबित",
  "checkpoints.statusMissed": "छूटा",
  "checkpoints.viewHistory": "स्कैन इतिहास देखें",
  "compliance.title": "गश्त अनुपालन",
  "compliance.subtitle": "प्रत्येक स्थान के कॉन्फ़िगर किए गए अंतराल के विरुद्ध चेकपॉइंट स्कैन स्थिति।",
  "compliance.advisory": "केवल सूचनार्थ। यह दृश्य बताता है कि प्रत्येक चेकपॉइंट को अंतिम बार कब स्कैन किया गया और उसके स्कैन अंतराल में कितना समय शेष है। यह कोई कार्य आवंटन, मार्ग या निर्देश नहीं है। कौन-से चेकपॉइंट किस क्रम में स्कैन किए जाते हैं, यह अधिकारी और उनके पर्यवेक्षक का निर्णय रहता है, जो उनके नियोक्ता के पोस्ट आदेशों और किसी भी उच्च-प्राथमिकता वाले कर्तव्यों के अधीन है।",
  "compliance.loadFailed": "अनुपालन स्थिति लोड नहीं हो सकी",
  "compliance.overdue": "अतिदेय",
  "compliance.overdueSub": "स्कैन अंतराल बीत चुका",
  "compliance.dueSoon": "जल्द देय",
  "compliance.dueSoonSub": "अंतराल की अंतिम तिमाही में",
  "compliance.onInterval": "अंतराल पर",
  "compliance.onIntervalSub": "अंतराल के भीतर स्कैन किया गया",
  "compliance.neverScanned": "रिकॉर्ड में कोई स्कैन नहीं",
  "compliance.neverScannedSub": "अतिदेय के रूप में नहीं गिना गया",
  "compliance.neverScannedNoteTitle": "इन्हें अतिदेय के रूप में क्यों नहीं गिना जाता:",
  "compliance.neverScannedNote": "जिस चेकपॉइंट का कोई स्कैन दर्ज नहीं है, उसके पास पार करने के लिए कोई अंतराल ही नहीं है। जो चेकपॉइंट अनुपालन ट्रैकिंग से पहले के हैं, वे साइट के लिए ऐतिहासिक बैकफ़िल चलने तक इसी तरह दिखते हैं, इसलिए उन्हें अतिदेय मानने से एक साथ हर चेकपॉइंट के लिए अलर्ट उठ जाएगा।",
  "compliance.openAlerts": "खुले अनुपालन अलर्ट",
  "compliance.checkpointStatus": "चेकपॉइंट स्थिति",
  "compliance.filterAttention": "अतिदेय और जल्द देय",
  "compliance.filterOverdue": "केवल अतिदेय",
  "compliance.filterAll": "सभी चेकपॉइंट",
  "compliance.emptyAll": "इस चयन के लिए कोई चेकपॉइंट नहीं मिला।",
  "compliance.emptyAttention": "कोई भी चेकपॉइंट अतिदेय या जल्द देय नहीं है।",
  "compliance.colCheckpoint": "चेकपॉइंट",
  "compliance.colStatus": "स्थिति",
  "compliance.colLastScan": "अंतिम स्कैन",
  "compliance.colInterval": "अंतराल",
  "compliance.colRemaining": "अंतराल में समय",
  "compliance.colScans24h": "स्कैन (24घं)",
  "compliance.status.OVERDUE": "अतिदेय",
  "compliance.status.DUE_SOON": "जल्द देय",
  "compliance.status.OK": "अंतराल पर",
  "compliance.status.NEVER_SCANNED": "रिकॉर्ड में कोई स्कैन नहीं",
  "compliance.minutesShort": "मिनट",
  "compliance.perDay": "प्रति दिन",
  "compliance.ruleLocation": "स्थान नियम",
  "compliance.ruleHospital": "साइट डिफ़ॉल्ट",
  "compliance.truncated": "केवल सबसे समय-संवेदनशील परिणाम दिखाए जा रहे हैं। बाकी देखने के लिए साइट के अनुसार सीमित करें।",
  "compliance.generatedAt": "स्थिति इस समय तक",
  "compliance.rules": "स्कैन अंतराल",
  "compliance.rulesTitle": "स्कैन अंतराल",
  "compliance.rulesSubtitle": "स्थान नियम साइट डिफ़ॉल्ट को ओवरराइड करता है, जो सिस्टम डिफ़ॉल्ट को ओवरराइड करता है।",
  "compliance.rulesEmpty": "कोई कस्टम नियम नहीं — सिस्टम डिफ़ॉल्ट लागू होता है।",
  "compliance.rulesLoadFailed": "नियम लोड नहीं हो सके",
  "compliance.rulesSaveFailed": "नियम सहेजा नहीं जा सका",
  "compliance.rulesDeleteFailed": "नियम हटाया नहीं जा सका",
  "compliance.rulesCreateFailed": "नियम बनाया नहीं जा सका",
  "compliance.rulesInvalid": "अंतराल और दैनिक न्यूनतम संख्याएँ होनी चाहिए",
  "compliance.systemDefault": "सिस्टम डिफ़ॉल्ट",
  "compliance.systemDefaultValue": "हर",
  "compliance.systemDefaultNote": "जिन साइटों का अपना कोई नियम नहीं है, उन्हें इसके विरुद्ध मापा जाता है।",
  "compliance.siteWide": "इस साइट के सभी चेकपॉइंट",
  "compliance.colAppliesTo": "लागू होता है",
  "compliance.colIntervalMin": "अंतराल (मिनट)",
  "compliance.colMinPerDay": "न्यूनतम / 24घं",
  "compliance.colActions": "कार्रवाइयां",
  "compliance.addSiteDefault": "साइट डिफ़ॉल्ट जोड़ें",
  "compliance.pickSiteToAdd": "इसके लिए डिफ़ॉल्ट जोड़ने हेतु एक साइट चुनें।",
  "officers.title": "अधिकारी",
  "officers.subtitle": "अधिकारी जो N नंबर से साइन ऑन करते हैं ताकि उनके स्कैन आरोपित हों। ये डैशबोर्ड लॉगिन नहीं हैं।",
  "officers.add": "अधिकारी जोड़ें",
  "officers.addTitle": "अधिकारी जोड़ें",
  "officers.editTitle": "अधिकारी संपादित करें",
  "officers.loadFailed": "अधिकारी लोड नहीं हो सके",
  "officers.saveFailed": "अधिकारी सहेजा नहीं जा सका",
  "officers.deactivateFailed": "अधिकारी निष्क्रिय नहीं किया जा सका",
  "officers.searchPlaceholder": "नाम, N नंबर या ईमेल से खोजें",
  "officers.filterActive": "सक्रिय",
  "officers.filterInactive": "निष्क्रिय",
  "officers.filterSuspended": "निलंबित",
  "officers.filterPending": "स्वीकृति लंबित",
  "officers.filterRejected": "अस्वीकृत",
  "officers.filterAll": "सभी स्थितियां",
  "officers.onShiftCount": "वर्तमान में साइन ऑन:",
  "officers.empty": "अभी तक कोई अधिकारी नहीं। स्कैन आरोपित करना शुरू करने के लिए एक जोड़ें।",
  "officers.emptySearch": "उस खोज से मेल खाने वाला कोई अधिकारी नहीं।",
  "officers.colOfficer": "अधिकारी",
  "officers.colNNumber": "N नंबर",
  "officers.colSite": "साइट",
  "officers.colStatus": "स्थिति",
  "officers.colShift": "वर्तमान शिफ्ट",
  "officers.colActions": "कार्रवाइयां",
  "officers.status.ACTIVE": "सक्रिय",
  "officers.status.PENDING": "स्वीकृति लंबित",
  "officers.status.INACTIVE": "निष्क्रिय",
  "officers.status.SUSPENDED": "निलंबित",
  "officers.status.REJECTED": "अस्वीकृत",
  "officers.onShiftSince": "तब से चालू",
  "officers.offShift": "साइन ऑन नहीं",
  "officers.scans": "स्कैन",
  "officers.deactivate": "निष्क्रिय करें",
  "officers.deactivateTitle": "अधिकारी को निष्क्रिय करें?",
  "officers.deactivateBody": "{name} अब साइन ऑन नहीं कर पाएंगे, और कोई भी खुली शिफ्ट बंद कर दी जाती है। उनका स्कैन इतिहास रखा जाता है और उन्हीं को आरोपित रहता है।",
  "officers.fieldNNumber": "N नंबर",
  "officers.fieldNNumberHint": "यदि आप शुरुआती N छोड़ देते हैं तो वह स्वचालित रूप से जोड़ दिया जाता है।",
  "officers.fieldName": "पूरा नाम",
  "officers.fieldSite": "साइट",
  "officers.fieldEmail": "ईमेल",
  "officers.fieldPhone": "फ़ोन",
  "officers.fieldStatus": "स्थिति",
  "officers.fieldStatusHint": "केवल ACTIVE अधिकारी साइन ऑन कर सकते हैं। ACTIVE से बदलने पर कोई भी खुली शिफ्ट बंद हो जाती है।",
  "officers.selectSite": "एक साइट चुनें",
  "officers.formRequired": "N नंबर, नाम और साइट आवश्यक हैं",
  "officers.pendingTitle": "लंबित नामांकन स्वीकृतियां",
  "officers.selfEnrolled": "स्व-नामांकित",
  "officers.enrolledAt": "साइन ऑन किया",
  "officers.enrollDistance": "साइट के दर्ज स्कैन क्षेत्र से {d}",
  "officers.enrollNoGps": "साइन-ऑन पर कोई GPS फ़िक्स नहीं",
  "officers.enrollSiteMismatch": "{chosen} चुना गया, लेकिन GPS ने {gps} की ओर संकेत किया — स्वीकृत करने से पहले पुष्टि करें कि कौन-सा सही है।",
  "officers.pendingNote": "ये पहचान बैज स्कैन के समय स्वयं-सूचित की गई थीं। स्वीकृत होने तक उनके स्कैन अस्थायी रूप से आरोपित होते हैं; अस्वीकार करने पर रिकॉर्ड और उसके स्कैन समीक्षा के लिए रखे जाते हैं।",
  "officers.approve": "स्वीकृत करें",
  "officers.reject": "अस्वीकार करें",
  "officers.approveTitle": "नामांकन स्वीकृत करें?",
  "officers.approveBody": "{n} को {site} पर अधिकारी के रूप में पुष्टि करता है। उनके लंबित स्कैन आरोपित रहते हैं और भविष्य के साइन-ऑन सामान्य रूप से काम करते हैं।",
  "officers.approveName": "अधिकारी का नाम (जैसा दिखना चाहिए)",
  "officers.approveFailed": "नामांकन स्वीकृत नहीं हो सका",
  "officers.rejectFailed": "नामांकन अस्वीकार नहीं हो सका",
  "patrolReports.title": "गश्त रिपोर्ट",
  "patrolReports.subtitle": "अधिकारी के अनुसार दर्ज गश्त गतिविधि, चेकपॉइंट कवरेज और अनुपालन अलर्ट इतिहास।",
  "patrolReports.tabOfficers": "अधिकारी",
  "patrolReports.tabCoverage": "कवरेज",
  "patrolReports.tabHistory": "अलर्ट इतिहास",
  "patrolReports.loadFailed": "रिपोर्ट लोड नहीं हो सकी",
  "patrolReports.badRange": "आरंभ तिथि, समाप्ति तिथि पर या उससे पहले होनी चाहिए",
  "patrolReports.startDate": "आरंभ तिथि",
  "patrolReports.endDate": "समाप्ति तिथि",
  "patrolReports.totalScans": "अवधि में स्कैन",
  "patrolReports.attributed": "किसी अधिकारी को आरोपित",
  "patrolReports.unattributed": "अनारोपित",
  "patrolReports.unattributedSub": "जब कोई अधिकारी साइन ऑन नहीं था, तब स्कैन किया गया",
  "patrolReports.officersListed": "सूचीबद्ध अधिकारी",
  "patrolReports.noOfficers": "इस चयन में कोई अधिकारी नहीं।",
  "patrolReports.colOfficer": "अधिकारी",
  "patrolReports.colSite": "साइट",
  "patrolReports.colShifts": "शिफ्ट",
  "patrolReports.colShiftTime": "शिफ्ट समय",
  "patrolReports.colScans": "स्कैन",
  "patrolReports.colCheckpoints": "चेकपॉइंट",
  "patrolReports.colScansHr": "स्कैन / घंटा",
  "patrolReports.colLastScan": "अंतिम स्कैन",
  "patrolReports.fullyCovered": "हर दिन कवर किया गया",
  "patrolReports.partiallyCovered": "कुछ दिन कवर किया गया",
  "patrolReports.uncovered": "अवधि में कोई स्कैन नहीं",
  "patrolReports.of": "में से",
  "patrolReports.coverageTitle": "चेकपॉइंट कवरेज",
  "patrolReports.coverageSort": "सबसे कम कवर किए गए चेकपॉइंट पहले।",
  "patrolReports.colCheckpoint": "चेकपॉइंट",
  "patrolReports.colDaysCovered": "कवर किए गए दिन",
  "patrolReports.colExpected": "अपेक्षित",
  "patrolReports.colStatusNow": "अभी स्थिति",
  "patrolReports.alertsRaised": "अवधि में अलर्ट",
  "patrolReports.alertsOpen": "अभी भी खुले",
  "patrolReports.alertsResolved": "हल किए गए",
  "patrolReports.repeatTitle": "सबसे अधिक बार अलर्ट उठाने वाले चेकपॉइंट",
  "patrolReports.colAlerts": "अलर्ट",
  "patrolReports.colOpen": "खुले",
  "patrolReports.colWorst": "सबसे अधिक अतिदेय",
  "patrolReports.colAvgResolve": "हल करने में औसत",
  "patrolReports.colLatest": "नवीनतम",
  "patrolReports.alertLog": "अलर्ट लॉग",
  "patrolReports.noAlerts": "इस अवधि में कोई अलर्ट नहीं।",
  "patrolReports.resolvedIn": "इसमें हल किया गया",
  "patrolReports.stateResolved": "हल किया गया",
  "patrolReports.stateOpen": "खुला",
  "emailPrefs.title": "ईमेल अलर्ट प्राथमिकताएं",
  "emailPrefs.subtitle": "चुनें कि आप प्रति साइट कौन-से अनुपालन ईमेल प्राप्त करते हैं।",
  "emailPrefs.loadFailed": "ईमेल प्राथमिकताएं लोड नहीं हो सकीं",
  "emailPrefs.saveFailed": "प्राथमिकता सहेजी नहीं जा सकी",
  "emailPrefs.noSites": "आपकी एक्सेस सूची में कोई साइट नहीं।",
  "emailPrefs.noPreference": "कोई प्राथमिकता सहेजी नहीं गई — फ़ॉलबैक लागू होता है",
  "emailPrefs.explainer": "जिन साइटों पर किसी ने प्राथमिकता नहीं सहेजी है, वहां सभी पर्यवेक्षकों और निदेशकों को ईमेल भेजने का फ़ॉलबैक लागू होता है। किसी साइट पर कोई भी प्राथमिकता सहेजने से वह केवल स्पष्ट विकल्पों पर स्विच हो जाती है।",
  "emailPrefs.overdue": "अतिदेय अलर्ट",
  "emailPrefs.overdueHint": "जब चेकपॉइंट अपना स्कैन अंतराल पार करते हैं तो तत्काल ईमेल",
  "emailPrefs.daily": "दैनिक सारांश",
  "emailPrefs.dailyHint": "प्रति दिन एक अनुपालन सारांश",
  "emailPrefs.officerSummary": "अधिकारी गतिविधि सारांश",
  "emailPrefs.officerSummaryHint": "साप्ताहिक दर्ज-गतिविधि रिपोर्ट। जब तक आप ऑप्ट इन न करें, बंद रहती है।",
  "emailPrefs.manageOthers": "इस साइट पर प्राप्तकर्ता प्रबंधित करें",
  "emailPrefs.noOthers": "यहां कोई अन्य प्राप्तकर्ता कॉन्फ़िगर नहीं है।",
  "emailPrefs.enrollEmail": "email@emoryhealthcare.org",
  "emailPrefs.enrollName": "नाम (वैकल्पिक)",
  "emailPrefs.enroll": "प्राप्तकर्ता जोड़ें",
  "emailPrefs.officerSummaryNote": "अधिकारी गतिविधि सारांश दर्ज स्कैन गतिविधि की एक निर्धारित रिपोर्ट है जिसमें उसकी चेतावनियां शामिल हैं — यह कोई प्रदर्शन स्कोर नहीं है, और यह कभी भी ऐसे किसी व्यक्ति को नहीं भेजी जाती जिसने ऑप्ट इन नहीं किया है।",
  "officerMap.open": "स्कैन इतिहास मानचित्र देखें",
  "officerMap.title": "स्कैन इतिहास",
  "officerMap.loadFailed": "स्कैन इतिहास लोड नहीं हो सका",
  "officerMap.empty": "चयनित अवधि में इस अधिकारी को आरोपित कोई GPS-टैग किया गया स्कैन नहीं।",
  "officerMap.firstScan": "पहला स्कैन",
  "officerMap.lastScan": "अंतिम स्कैन",
  "officerMap.scans": "स्कैन",
  "officerMap.ofTotal": "{n} स्कैन में से",
  "officerMap.note": "यहां केवल इस अधिकारी को आरोपित स्कैन दिखाई देते हैं। साइन ऑन न होने के दौरान किए गए स्कैन अनारोपित होते हैं और नहीं दिखाए जाते।",
  "patrolReports.officersTableTitle": "अधिकारी के अनुसार दर्ज गतिविधि",


  // --- Officer detail page (synced from en.ts) ---
  "officerDetail.allOfficers": "सभी अधिकारी",
  "officerDetail.backToOfficers": "अधिकारियों पर वापस जाएं",
  "officerDetail.notFound": "अधिकारी नहीं मिला।",
  "officerDetail.loadFailed": "अधिकारी लोड करने में विफल",
  "officerDetail.selfEnrolled": "स्व-नामांकित",
  "officerDetail.addedBySupervisor": "पर्यवेक्षक द्वारा जोड़ा गया",
  "officerDetail.memberSince": "{date} से सदस्य",
  "officerDetail.totalScans": "कुल स्कैन",
  "officerDetail.shifts": "शिफ्ट",
  "officerDetail.activeDays": "सक्रिय दिन",
  "officerDetail.avgShift": "औसत / शिफ्ट",
  "officerDetail.noShiftsYet": "अभी तक कोई शिफ्ट नहीं",
  "officerDetail.scansPerShift": "प्रति शिफ्ट स्कैन",
  "officerDetail.lastActive": "अंतिम सक्रिय",
  "officerDetail.whereScanned": "{name} ने कहां स्कैन किया",
  "officerDetail.mapToLight": "मानचित्र को हल्की टाइल पर स्विच करें",
  "officerDetail.mapToDark": "मानचित्र को गहरी टाइल पर स्विच करें",
  "officerDetail.light": "हल्का",
  "officerDetail.dark": "गहरा",
  "officerDetail.noGpsScans": "पिछले 30 दिनों में मानचित्र पर दिखाने के लिए कोई GPS-टैग किया गया स्कैन नहीं।",
  "officerDetail.scanActivityTitle": "स्कैन गतिविधि — पिछले {n} दिन",
  "officerDetail.noScansInDays": "पिछले {n} दिनों में कोई स्कैन दर्ज नहीं हुआ।",
  "officerDetail.scanHistory": "स्कैन इतिहास",
  "officerDetail.searchScans": "स्कैन खोजें…",
  "officerDetail.colDateTime": "दिनांक और समय",
  "officerDetail.colLocation": "स्थान",
  "officerDetail.colHospital": "अस्पताल",
  "officerDetail.colCoordinates": "निर्देशांक",
  "officerDetail.noScansMatch": "“{q}” से मेल खाने वाला कोई स्कैन नहीं।",
  "officerDetail.showingScans": "{total} दर्ज स्कैन में से {shown} दिखाए जा रहे हैं (पिछले 30 दिन)।",
  "officerDetail.timelineRange": "{n} स्कैन · सबसे पुराना → सबसे नया",
  "officerDetail.hoverTimeline": "किसी स्कैन का पता लगाने के लिए टाइमलाइन पर होवर करें",
  "officerDetail.timelineCaption": "हर बिंदु एक स्कैन है, जो उसके होने के समय के अनुसार रखा गया है और सबसे पुराने-नीले से सबसे नए-लाल तक रंगा गया है। मानचित्र पर उसे हाइलाइट करने के लिए होवर करें। स्कैन के बीच कोई पथ नहीं खींचा जाता — केवल दर्ज किए गए स्कैन स्थान दिखाए जाते हैं।",


  // --- Scan Map anomaly/misplaced views (synced from en.ts) ---
  "map.officer": "अधिकारी",
  "map.clearOfficer": "अधिकारी फ़िल्टर साफ़ करें",
  "map.searchOfficer": "अधिकारी खोजें…",
  "map.misplacedTitle": "केवल वे स्कैन दिखाएं जिनका GPS अपने चेकपॉइंट से 1कि.मी. से अधिक दूर पड़ा",
  "map.misplacedOn": "गलत स्थान पर",
  "map.misplacedOff": "गलत स्थान पर",
  "map.anomaliesTitle": "असामान्य के रूप में फ़्लैग किए गए स्कैन दिखाएं — अधिकारी की असंभव यात्रा, या अपने ही अस्पताल से दूर दर्शाया गया स्कैन",
  "map.anomalies": "असामान्यताएं",
  "map.popupOfficer": "अधिकारी:",
  "map.anomalousMovement": "असामान्य — इस अधिकारी के स्कैन के बीच असंभव यात्रा",
  "map.anomalousHospital": "असामान्य — अपने लेबल किए गए अस्पताल से दूर दर्शाया गया",
  "map.anomalousBoth": "असामान्य — असंभव यात्रा और अपने अस्पताल से दूर",
  "map.metersFromCheckpoint": "अपने चेकपॉइंट से {n} मी दूर",
  "map.scansLabel": "स्कैन",
  "map.earliest": "सबसे पुराना",
  "map.latest": "नवीनतम",

};

export default hi;
